const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function trackEvent(name, params = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...params });
  if (typeof window.gtag === "function") window.gtag("event", name, params);
}

export function trackOutbound({ break_slug, destination_url, placement }) {
  const payload = { break_slug, destination_url, placement };
  trackEvent("select_break_booking", payload);
  try {
    navigator.sendBeacon(
      `${BACKEND}/api/analytics/outbound`,
      new Blob([JSON.stringify(payload)], { type: "application/json" })
    );
  } catch (e) {
    /* non-blocking */
  }
}

// Build a UTM-tagged SPE link (packages or attraction detail pages)
export function speLink(base, content) {
  return `${base}?utm_source=theperfectbreak&utm_medium=referral_site&utm_campaign=tpb_site&utm_content=${encodeURIComponent(content)}`;
}
